// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperNewsStory-cls1_vMV","cls2":"PaperNewsStory-cls2_EQj PaperNewsStory-cls1_vMV"};